import { render } from "./LayoutWithNavigation.vue?vue&type=template&id=3c2d4e8a&scoped=true"
import script from "./LayoutWithNavigation.vue?vue&type=script&lang=js"
export * from "./LayoutWithNavigation.vue?vue&type=script&lang=js"

import "./LayoutWithNavigation.vue?vue&type=style&index=0&id=3c2d4e8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2d4e8a"]])

export default __exports__